import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { configureStore } from './reduxModules/store';
import * as firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore";
import "firebase/functions"
import "antd/dist/antd.css";
import { Provider } from 'react-redux';

const firebaseConfig = {
  apiKey: "AIzaSyA9hUXiaDjdlb19JyccBCpMjtZZfL55-Yk",
  authDomain: "uc-care.firebaseapp.com",
  databaseURL: "https://uc-care.firebaseio.com",
  projectId: "uc-care",
  storageBucket: "uc-care.appspot.com",
  messagingSenderId: "599752533904",
  appId: "1:599752533904:web:85f1d665d0ef603ff03515",
  measurementId: "G-MC9G7KJBZM"
};

firebase.initializeApp(firebaseConfig);

const store = configureStore().store;

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
